import React from "react";
import { FiRefreshCw, FiCreditCard, FiDatabase, FiGift } from "react-icons/fi";
import { motion } from "framer-motion";

const cards = [
  {
    icon: <FiRefreshCw className="w-5 h-5 text-primary" />,
    title: "Top Online Casinos",
    body: "Find the best bonuses available and maximize your winnings.",
  },
  {
    icon: <FiCreditCard className="w-5 h-5 text-primary" />,
    title: "Payment Methods",
    body: "Learn about the various payment options to suit your needs.",
  },
  {
    icon: <FiDatabase className="w-5 h-5 text-primary" />,
    title: "Slots Galore",
    body: "Explore a wide range of exciting slot games and their features.",
  },
  {
    icon: <FiGift className="w-5 h-5 text-primary" />,
    title: "Bonuses and Promotions",
    body: "Stay updated on the latest promotions and offers.",
  },
];

const ExploreSection = () => {
  return (
    <section className="bg-background dark:bg-darkbg text-text dark:text-textDark py-16 sm:py-24 transition-colors duration-300">
      <div className="w-full mx-auto max-w-[1400px] 2xl:max-w-[1600px] px-6 xl:px-20">
        {/* Eyebrow */}
        <motion.p
          className="text-center text-text/70 dark:text-textDark/70 text-sm font-medium mb-3"
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Explore
        </motion.p>

        {/* Heading */}
        <motion.h2
          className="text-center font-extrabold tracking-tight text-3xl sm:text-5xl mb-4"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Everything you need to choose
          <br className="hidden sm:block" />
          the best online casino for you
        </motion.h2>

        {/* Subhead */}
        <motion.p
          className="text-center text-text/80 dark:text-textDark/80 max-w-3xl mx-auto mb-10 sm:mb-14"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          We break all aspects of online casinos down for you, providing you
          with the best information available to make an educated decision.
        </motion.p>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.35, delay: i * 0.06 }}
              className="bg-surface dark:bg-surfaceDark border border-border dark:border-borderDark rounded-xl shadow-sm hover:shadow-md transition-shadow h-full flex flex-col"
            >
              <div className="p-5 sm:p-6 pb-4 flex flex-col items-center text-center">
                <div className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-primary/10 mb-3 border border-border dark:border-borderDark">
                  {c.icon}
                </div>
                <h4 className="font-semibold mb-1 whitespace-nowrap text-text dark:text-textDark">
                  {c.title}
                </h4>
                <p className="text-text/70 dark:text-textDark/70 text-sm leading-relaxed">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExploreSection;
